// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import {isLoggedIn} from '@/utils/auth';

axios.defaults.withCredentials = true;

axios.interceptors.response.use(response => {
   return response;
}, error => {
  if (error.response.status === 403) {
    localStorage.removeItem("user");
    localStorage.removeItem("expiration_date");
    
    router.push("login");
  }
  throw error;
});

axios.interceptors.request.use(config => {
  if (!isLoggedIn() && (router.currentRoute.matched.some(record => record.meta.requiresAuth))) {
    router.push("login");
  } 
  return config;
});

Vue.prototype.$http = axios;
Vue.config.productionTip = process.env.NODE_ENV=="development";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js